module.exports = __webpack_public_path__ + "img/button_login-01.ba357c54.svg";